import axios from "core/network/interceptor";
import {
  GetRegistrationStepsColumnUrl,
  GetRegistrationStepsUrl,
  PutRegistrationStepUrl,
} from "./constants";
import { Candidate, Column } from "./interface";

interface ApiResponseWithInfo {
  info: {
    current_page: number;
    total_pages: number;
    prev_page: number;
    next_page: number;
    last_page: boolean;
  };
}

export interface GetRegistrationStepsResponse extends ApiResponseWithInfo {
  data: Column[];
}

export interface GetCandidatesByColumnIdResponse extends ApiResponseWithInfo {
  candidates: Candidate[];
}

export const GetRegistrationSteps =
  async (): Promise<GetRegistrationStepsResponse> => {
    const response = await axios.get(GetRegistrationStepsUrl);
    return response.data;
  };

export const GetCandidatesByColumnId = async (
  columnId: number,
  search: string | null,
  filters: { qualification?: string[] },
  page: number = 1
): Promise<GetCandidatesByColumnIdResponse> => {
  const response = await axios.get(
    GetRegistrationStepsColumnUrl(columnId, page, search, filters)
  );
  return response.data;
};

export interface UpdateCandidateRegistrationStepDTO {
  new_step_id: number;
  previous_step_id: number;
  candidate_id: number;
}

export interface UpdateCandidateRegistrationStepResponseDTO {
  new_step_id: number;
  previous_step_id: number;
  candidate_id: number;
  scheduled_deletion_at: number | null;
}

export const UpdateCandidateRegistrationStep = async ({
  new_step_id,
  previous_step_id,
  candidate_id
}: UpdateCandidateRegistrationStepDTO): Promise<UpdateCandidateRegistrationStepResponseDTO> => {
  const { data } = await axios.put(PutRegistrationStepUrl(new_step_id), {
    previous_step_id,
    candidate_id,
  });

  return {
    new_step_id,
    previous_step_id,
    candidate_id,
    scheduled_deletion_at: new Date(data.candidate.scheduled_deletion_at).getTime()
  };
};
